import { baseApi } from '@shared/api/baseApi.js';

const getCompanyById = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyById: builder.query({
			query: ({ companyId }) => `/v2/companies/${companyId}`,
			providesTags: (_result, _error, { companyId }) => [
				{ type: 'CompanyProfile', id: `${companyId}` },
			],
		}),
	}),
});

export const { useGetCompanyByIdQuery } = getCompanyById;

// {
//     "id": "94c102fd-8bac-4845-acd0-5cb742258463",
//     "name": "New Company 013",
//     "addressLine1": "Siegfried-Berger-Straße 30",
//     "postalCode": "10115",
//     "city": "Berlin",
//     "country": "DEU",
//     "email": "user2@example2.com",
//     "phone": "+493066771235",
//     "accountingEmail": null,
//     "logoUrl": "https://regional-hero-2.s3.eu-central-1.amazonaws.com/HR_benefit_Logo_positiv_horiz_V1_02.png",
//     "onboardingStatus": "Completed",
//     "onboardingId": "1ad4aeee-50c2-4239-a924-31556123b822",
//     "sddMandateId": null,
//     "sddStatus": null,
//     "createdAt": "2026-04-12T11:17:08.000Z",
//     "updatedAt": "2026-04-12T11:18:08.000Z"
// }

// [
// 	{
// 		id: '0f2faebf-ec4b-4650-8d35-83a7afb197b8', - id счета.
// 		iban: 'DE62202208000026011932',
// 		status: 'active',
// 		currentBalance: 0,
// 		currency: 'EUR',
// 	},
// ];
